export default __webpack_public_path__ + "static/media/tree.ebe2142f.png";